// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Person48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Person48Filled: FC<Person48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M24 23.95c-2.2 0-4-.7-5.4-2.1-1.4-1.4-2.1-3.2-2.1-5.4s.7-4 2.1-5.4c1.4-1.4 3.2-2.1 5.4-2.1s4 .7 5.4 2.1c1.4 1.4 2.1 3.2 2.1 5.4s-.7 4-2.1 5.4c-1.4 1.4-3.2 2.1-5.4 2.1ZM8 40v-4.7c0-1.267.317-2.35.95-3.25A6.1 6.1 0 0 1 11.4 30c2.233-1 4.375-1.75 6.425-2.25S21.933 27 24 27s4.117.259 6.15.775c2.033.517 4.167 1.259 6.4 2.225a6.029 6.029 0 0 1 2.5 2.05c.633.9.95 1.983.95 3.25V40H8Z" />
        </svg>
    );
};

export default Person48Filled;
